import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getThreeDReport=()=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_3D_REPORT_START
    })
    await axios.get("/threeDReports/master")
            .then(response=>dispatch({
                type:actionTypes.GET_3D_REPORT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_3D_REPORT_FAIL,
                payload:getMessage(error)
            }))
}